import https from "./https";
import store from "@/store"

const organization = store.state.general.organization;

const flaps = {
  query(params) {
    return https.get(
      `admin/organizations/${organization.id}/twodfire/query`, 
      { params }
    );
  }
};

export default flaps

